import React from 'react'
import Nav from '../nav/Nav'

function CyberSecurityService() {
  return (
    <>
    
<div>
  <style dangerouslySetInnerHTML={{__html: "\n        .box {\n            height: 150px;\n            /* background: blue; */\n            color: white;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 24px;\n            margin: 10px;\n        }\n\n        .secure-title {\n            font-family: 'Oswald', sans-serif;\n            font-weight: 700;\n            letter-spacing: 0.5px;\n            text-transform: uppercase;\n            line-height: 1.1;\n        }\n    " }} />
  <div className="sub-banner-section-outer position-relative">
    <header>
     <Nav />
    </header>
    {/* SUB-BANNER SECTION */}
    <section className="banner-section position-relative">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="banner-section-content">
              <h1 className="text-white" >Cybersecurity Services</h1>
              {/*<p class="text-white" data-aos="fade-right">Cybersecurity </p>*/}
              <div className="btn_wrapper" >
                <span> Home </span><i className="fa-solid fa-angles-right" aria-hidden="true" />
                <span className="sub_span">Cybersecurity Services</span>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
            <div className="banner_image position-relative" style={{left: '60px !important'}}>
              <figure className="banner_main_image mb-0 left_right_shape">
                <img src="./assets/images/security.png" alt />
              </figure>
              <figure className="banner_image_bottom_shape mb-0 position-absolute top_bottom_shape">
                <img src="./assets/images/sub_banner_image_bottom_shape.png" alt className="img-fluid" />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </section>
    <figure className="banner_top_shape mb-0 position-absolute top_bottom_shape">
      <img src="./assets/images/sub_banner_top_shape.png" alt className="img-fluid" />
    </figure>
    <figure className="banner_background_shape mb-0 position-absolute left_right_shape">
      <img src="./assets/images/sub_banner_background_shape.png" alt />
    </figure>
  </div>
  {/* STATISTICS SECTION */}
  <section className="statistics_section position-relative position-relative second p-5" id="section2">
    <div className="dcc-overlay" />
    <div className="container align-items-start h-100">
      <div className="row position-relative" style={{zIndex: 1000}}>{/*  */}
        <div className="col-12">
          <div className="statistics_content mb-5 mt-0 pt-0 text-white " >
            <h3 className="mb-2 text-align-left">Why GazTecForge ?</h3>
            <ul>
              <li style={{textAlign: 'left !important'}}>
                Cybersecurity services delivering precise risk mitigation, applying our tailored solutions for all business types
              </li>
              <li style={{textAlign: 'left !important'}}>
                Deep expertise in U.S. government cybersecurity frameworks (CMMC, NIST, FedRAMP)
              </li>
              <li style={{textAlign: 'left !important'}}>
                Access to cleared, vetted cybersecurity professionals
              </li>
              <li style={{textAlign: 'left !important'}}>
                Flexible contracting models: Advisory, Staff Augmentation, or Full-Service Support
              </li>
            </ul>
          </div>
        </div>
      </div>
      <figure className="statistics_left_shape mb-0 position-absolute top_bottom_shape">
        <img src="<?= $url; ?>/assets/images/statistics_left_shape.png" alt className="img-fluid" />
      </figure>
      <figure className="statistics_right_shape mb-0 position-absolute top_bottom_shape">
        <img src="<?= $url; ?>/assets/images/statistics_right_shape.png" alt className="img-fluid" />
      </figure>
    </div>
  </section>
  {/* PRODUCT SECTION */}
  <section className="services_section position-relative section position-relative" style={{paddingTop: 0}}>
    <div className="container align-items-center h-100">
      <div className="row position-relative" style={{zIndex: 1000}}>
        {/*  */}
        {/* <div class="col-12 col-lg-5">

              <div class="hover-effect" data-aos="fade-down">

                  <figure>

                      <img src="./assets/images/heavy.png" alt="" class="img-fluid hover-effect">

                  </figure>

              </div>

          </div> */}
        <div className="col-12">
          <h2 className="text-center mb-4 mt-5 secure-title text-light" >Managed Security Services (MSSP)</h2>
          <div className="row my-3" >
            <div className="col-md-9">
              <div className="container pb-5 pt-2 text-light">
                {/* <h2 class="text-center mb-4 mt-5 secure-title" >Managed Security Services (MSSP)</h2> */}
                <div id="carouselExampleIndicators" className="carousel slide slide-dcc " data-ride="carousel" data-interval="false" >
                  <ol className="carousel-indicators">
                    <li data-target="#carouselExampleIndicators" data-slide-to={0} />
                    <li data-target="#carouselExampleIndicators" data-slide-to={1} className="active" />
                  </ol>
                  <div className="carousel-inner">
                    <div className="carousel-item active px-5">
                      <section className="mb-5" >
                        {/* <h2>Managed Security Services (MSSP)</h2> */}
                        <div className="row">
                          <div className="col-md-12">
                            <h4 style={{textAlign: 'left'}}>Proactive security operations, delivered as a service.</h4>
                            <p><strong>We provide </strong>
                              continuous protection through monitoring, management, and threat detection. From endpoint to firewall, our MSSP offering ensures your security solutions are fully deployed, maintained, and optimized.</p>
                          </div>
                        </div>
                      </section>
                    </div>
                    <div className="carousel-item px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 style={{textAlign: 'left'}}>Key Capabilities</h4>
                            <ul>
                              <li>24/7 Threat Monitoring &amp; Alerting</li>
                              <li>Endpoint Detection &amp; Response (EDR)</li>
                              <li>Application Management</li>
                              <li>Firewall Management &amp; Log Review</li>
                              <li>Vulnerability Management &amp; Patch Support</li>
                              <li>Reporting &amp; Compliance Documentation</li>
                            </ul>
                            <p><strong>Refer to our </strong>
                              <a href="cyber-security.php/#secops">SecOps</a>
                              &amp;
                              <a href="cyber-security.php?">NetOps</a> Solutions
                            </p>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                  <button className="carousel-control-prev" style={{backgroundColor: '#ff000000', border: 'none'}} type="button" data-target="#carouselExampleIndicators" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="sr-only">Previous</span>
                  </button>
                  <button className="carousel-control-next" style={{backgroundColor: '#ff000000', border: 'none'}} type="button" data-target="#carouselExampleIndicators" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="sr-only">Next</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <img src="./assets/images/cyber-services/mssp.png" alt width="100%" style={{borderRadius: '2rem'}} />
            </div>
          </div>
          <div className="container pb-5 pt-2 text-light">
            <h2 className="text-center mb-4 secure-title" >
              Cybersecurity &amp; Risk Management Consulting
            </h2>
            <div className="row my-3" >
              {/* الصورة يسار */}
              <div className="col-md-3">
                <img src="./assets/images/cyber-services/crmc.png" alt width="100%" style={{borderRadius: '2rem'}} />
              </div>
              {/* الكاروسيل يمين (نص فقط) */}
              <div className="col-md-9">
                <div id="carouselCRMC" className="carousel slide slide-dcc" data-interval="false" data-ride="carousel" >
                  <ol className="carousel-indicators">
                    <li data-target="#carouselCRMC" data-slide-to={0} className="active" />
                    <li data-target="#carouselCRMC" data-slide-to={1} />
                  </ol>
                  <div className="carousel-inner">
                    {/* Slide 1 */}
                    <div className="carousel-item active px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">Expert guidance across architecture, compliance, and risk.</h4>
                            <p>
                              <strong>We help</strong> organizations build secure, compliant environments by aligning technology, people, and process.
                              Whether you're maturing your security program or preparing for audits, our consultants deliver clarity and results.
                            </p>
                          </div>
                        </div>
                      </section>
                    </div>
                    {/* Slide 2 */}
                    <div className="carousel-item px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">Focus Areas</h4>
                            <ul>
                              <li>Security Architecture Design &amp; Hardening</li>
                              <li>Cloud Security &amp; Network Security Reviews</li>
                              <li>Compliance Gap Assessments (NIST, HIPAA, FedRAMP)</li>
                              <li>Risk Management &amp; Threat Modeling</li>
                              <li>Policy Development &amp; Technical Control Mapping</li>
                            </ul>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                  <button className="carousel-control-prev" style={{backgroundColor: '#0000', border: 'none'}} type="button" data-target="#carouselCRMC" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="sr-only">Previous</span>
                  </button>
                  <button className="carousel-control-next" style={{backgroundColor: '#0000', border: 'none'}} type="button" data-target="#carouselCRMC" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="sr-only">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="container pb-5 pt-2 text-light">
            <h2 className="text-center mb-4 secure-title" >SOC Advisory</h2>
            <div className="row my-3" >
              {/* الكاروسيل يسار */}
              <div className="col-md-9">
                <div id="carouselSOC" className="carousel slide slide-dcc" data-interval="false" data-ride="carousel" >
                  <ol className="carousel-indicators">
                    <li data-target="#carouselSOC" data-slide-to={0} className="active" />
                    <li data-target="#carouselSOC" data-slide-to={1} />
                  </ol>
                  <div className="carousel-inner">
                    {/* Slide 1 */}
                    <div className="carousel-item active px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">Build or improve your Security Operations Center (SOC).</h4>
                            <p>
                              <strong>Whether</strong> you're starting from scratch or optimizing an existing SOC, we provide strategic and tactical support.
                              We align your people, processes, and tools for effective threat detection and response.
                            </p>
                          </div>
                        </div>
                      </section>
                    </div>
                    {/* Slide 2 */}
                    <div className="carousel-item px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">Advisory Services Include:</h4>
                            <ul>
                              <li>SOC Maturity Assessment</li>
                              <li>Technology Stack Review (SIEM, SOAR, EDR)</li>
                              <li>Use Case &amp; Playbook Development</li>
                              <li>Threat Intelligence Integration</li>
                              <li>Incident Response Planning &amp; Tabletop Exercises</li>
                            </ul>
                            <p><strong>Refer to our </strong>
                              <a href="cyber-security.php/#secops">SecOps</a>
                              &amp;
                              <a href="cyber-security.php?">NetOps</a> Solutions
                            </p>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                  <button className="carousel-control-prev" style={{backgroundColor: '#0000', border: 'none'}} type="button" data-target="#carouselSOC" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="sr-only">Previous</span>
                  </button>
                  <button className="carousel-control-next" style={{backgroundColor: '#0000', border: 'none'}} type="button" data-target="#carouselSOC" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="sr-only">Next</span>
                  </button>
                </div>
              </div>
              {/* الصورة يمين */}
              <div className="col-md-3">
                <img src="./assets/images/cyber-services/sa.png" alt width="100%" style={{borderRadius: '2rem'}} />
              </div>
            </div>
          </div>
          <div className="container pb-5 pt-2 text-light">
            <h2 className="text-center mb-4 secure-title" >Virtual CISO (vCISO)</h2>
            <div className="row my-3" >
              {/* الصورة يسار */}
              <div className="col-md-3">
                <img src="./assets/images/cyber-services/vciso.png" alt width="100%" style={{borderRadius: '2rem'}} />
              </div>
              {/* الكاروسيل يمين */}
              <div className="col-md-9">
                <div id="carouselVCISO" className="carousel slide slide-dcc" data-interval="false" data-ride="carousel" >
                  <ol className="carousel-indicators">
                    <li data-target="#carouselVCISO" data-slide-to={0} className="active" />
                    <li data-target="#carouselVCISO" data-slide-to={1} />
                  </ol>
                  <div className="carousel-inner">
                    {/* Slide 1 */}
                    <div className="carousel-item active px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">Executive-level cybersecurity leadership on demand.</h4>
                            <p>
                              <strong>Our vCISO</strong> service delivers experienced security leadership without the full-time overhead.
                              We help organizations define strategy, manage risk, and meet board-level expectations for cybersecurity governance.
                            </p>
                          </div>
                        </div>
                      </section>
                    </div>
                    {/* Slide 2 */}
                    <div className="carousel-item px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">What We Deliver:</h4>
                            <ul>
                              <li>Cybersecurity Program Development</li>
                              <li>Board &amp; Executive Reporting</li>
                              <li>Security Roadmaps &amp; Budgets</li>
                              <li>Audit Readiness &amp; Compliance Oversight</li>
                              <li>Vendor Risk &amp; Supply Chain Assessments</li>
                            </ul>
                            <p><strong>Refer to our </strong>
                              <a href="cyber-security.php/#secops">SecOps</a>
                              &amp;
                              <a href="cyber-security.php?">NetOps</a> Solutions
                            </p>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                  <button className="carousel-control-prev" style={{backgroundColor: '#0000', border: 'none'}} type="button" data-target="#carouselVCISO" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="sr-only">Previous</span>
                  </button>
                  <button className="carousel-control-next" style={{backgroundColor: '#0000', border: 'none'}} type="button" data-target="#carouselVCISO" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="sr-only">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="container pb-5 pt-2 text-light">
            <h2 className="text-center mb-4 secure-title" >
              Government Cybersecurity &amp; Compliance Services
            </h2>
            <div className="row my-3" >
              {/* الكاروسيل يسار */}
              <div className="col-md-9">
                <div id="carouselGCCS" className="carousel slide slide-dcc" data-interval="false" data-ride="carousel" >
                  <ol className="carousel-indicators">
                    <li data-target="#carouselGCCS" data-slide-to={0} className="active" />
                    <li data-target="#carouselGCCS" data-slide-to={1} />
                    <li data-target="#carouselGCCS" data-slide-to={2} />
                  </ol>
                  <div className="carousel-inner">
                    {/* Slide 1 */}
                    <div className="carousel-item active px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">Advisory. Readiness. Skilled Personnel.</h4>
                            <p><strong>At GazTec,</strong>
                              we support government agencies and federal contractors with specialized cybersecurity services, compliance readiness, and cleared personnel.
                              Whether you're seeking CMMC guidance, NIST alignment, or experienced cyber professionals to fulfill a support contract — we are your trusted partner.
                            </p>
                            <p>
                              We combine compliance expertise with contractor capabilities, helping agencies and prime contractors meet mission-critical security needs while staying aligned with federal standards and mandates.
                            </p>
                          </div>
                        </div>
                      </section>
                    </div>
                    {/* Slide 2 */}
                    <div className="carousel-item px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">What We Deliver:</h4>
                            <p>Cybersecurity Compliance &amp; Readiness Services</p>
                            <ul>
                              <li>CMMC 2.0 Gap Assessments &amp; Implementation Support</li>
                              <li>NIST 800-171 / 800-53 Control Mapping &amp; Documentation</li>
                              <li>FedRAMP, FISMA &amp; DoD RMF Advisory</li>
                              <li>System Security Plans (SSP), POA&amp;Ms, and Audit Readiness</li>
                              <li>Security Architecture Review (On-Prem, Cloud, Hybrid)</li>
                              <li>Policy &amp; Procedure Development (Aligned to federal frameworks)</li>
                            </ul>
                          </div>
                        </div>
                      </section>
                    </div>
                    {/* Slide 3 */}
                    <div className="carousel-item px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">What We Deliver:</h4>
                            <p>Cybersecurity Staffing &amp; Support Contracts</p>
                            <ul>
                              <li>Cleared Cybersecurity Professionals (Secret, Top Secret, TS/SCI)</li>
                              <li>Contract Support for Government Programs &amp; Federal Primes</li>
                              <li>Staff Augmentation (SOC Analysts, Security Engineers, ISSOs, Auditors)</li>
                              <li>Surge Support for RMF, Compliance, and Assessment Activities</li>
                              <li>Full-time or Project-Based Cyber Talent for Federal Contracts</li>
                              <li>Contractor onboarding support with active participation in SCIF or classified environments where applicable</li>
                            </ul>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                  <button className="carousel-control-prev" style={{backgroundColor: '#0000', border: 'none'}} type="button" data-target="#carouselGCCS" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="sr-only">Previous</span>
                  </button>
                  <button className="carousel-control-next" style={{backgroundColor: '#0000', border: 'none'}} type="button" data-target="#carouselGCCS" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="sr-only">Next</span>
                  </button>
                </div>
              </div>
              {/* الصورة يمين */}
              <div className="col-md-3">
                <img src="./assets/images/cyber-services/gccs.png" alt width="100%" style={{borderRadius: '2rem'}} />
              </div>
            </div>
          </div>
          <div className="container pb-5 pt-2 text-light">
            <h2 className="text-center mb-4 secure-title" >
              Cybersecurity Training &amp; Certification Advisory
            </h2>
            <div className="row my-3" >
              {/* الصورة يسار */}
              <div className="col-md-3">
                <img src="./assets/images/cyber-services/ctca.png" alt width="100%" style={{borderRadius: '2rem'}} />
              </div>
              {/* الكاروسيل يمين */}
              <div className="col-md-9">
                <div id="carouselCTCA" className="carousel slide slide-dcc" data-interval="false" data-ride="carousel" >
                  <ol className="carousel-indicators">
                    <li data-target="#carouselCTCA" data-slide-to={0} className="active" />
                    <li data-target="#carouselCTCA" data-slide-to={1} />
                    <li data-target="#carouselCTCA" data-slide-to={2} />
                  </ol>
                  <div className="carousel-inner">
                    {/* Slide 1 */}
                    <div className="carousel-item active px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">Build the right skills, without the guesswork.</h4>
                            <p>
                              <strong>GazTech</strong> streamlines cybersecurity training by identifying tailored certification paths for your team,
                              optimizing budget and time. We provide a customized roadmap and manage registration and procurement,
                              eliminating the hassle of evaluating options and handling logistics.
                            </p>
                            <p>➔ We assess your team's skills, compliance needs, and goals to recommend targeted certifications and training programs.</p>
                            <p>➔ We handle sourcing, registration, and scheduling, guiding you seamlessly through the training process.</p>
                          </div>
                        </div>
                        {/* Logos Carousel */}
                      </section>
                    </div>
                    {/* Slide 2 */}
                    <div className="carousel-item px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">Our Support Includes:</h4>
                            <ul>
                              <li>Skills Gap Assessment &amp; Role Mapping</li>
                              <li>Certification Planning (e.g., CISSP, CEH, CISM, Security+, etc.)</li>
                              <li>Compliance-Aligned Training Recommendations (e.g., for HIPAA, NIST, PCI)</li>
                              <li>Course Provider Vetting (e.g., SANS, ISC², EC-Council, CompTIA)</li>
                              <li>Enrollment Assistance &amp; Procurement Support</li>
                              <li>Recertification &amp; Continuing Education Tracking</li>
                            </ul>
                          </div>
                        </div>
                      </section>
                    </div>
                    {/* Slide 3 */}
                    <div className="carousel-item px-5">
                      <section className="mb-5" >
                        <div className="row">
                          <div className="col-md-12">
                            <h4 className="text-left">Who It's For:</h4>
                            <ul>
                              <li>SMBs building out a security team</li>
                              <li>Government contractors meeting certification mandates</li>
                              <li>Enterprises planning team upskilling or compliance-driven training</li>
                              <li>Organizations operating in regulated or classified environments where applicable</li>
                            </ul>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                  <button className="carousel-control-prev" style={{backgroundColor: '#0000', border: 'none'}} type="button" data-target="#carouselCTCA" data-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="sr-only">Previous</span>
                  </button>
                  <button className="carousel-control-next" style={{backgroundColor: '#0000', border: 'none'}} type="button" data-target="#carouselCTCA" data-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="sr-only">Next</span>
                  </button>
                </div>
              </div>
            </div>
            <div className="owl-carousel owl-theme mt-3">
              <div className="item" style={{width: '160.8px', marginRight: 10, background: 'white', borderRadius: 11}}>
                <div className="box">
                  <img src="./assets/images/logos/ec.png" alt />
                </div>
              </div>
              <div className="item" style={{width: '160.8px', marginRight: 10, background: 'white', borderRadius: 11}}>
                <div className="box">
                  <img src="./assets/images/logos/sans.png" alt />
                </div>
              </div>
              <div className="item" style={{width: '160.8px', marginRight: 10, background: 'white', borderRadius: 11}}>
                <div className="box">
                  <img src="./assets/images/logos/isc.png" alt />
                </div>
              </div>
              <div className="item" style={{width: '160.8px', marginRight: 10, background: 'white', borderRadius: 11}}>
                <div className="box">
                  <img src="./assets/images/logos/compatia.png" alt />
                </div>
              </div>
            </div>
          </div>
          <figure className="services_background_shape mb-0 position-absolute left_right_shape" style={{zIndex: -1}}>
            <img src="./assets/images/services_background_shape.png" alt className="img-fluid" />
          </figure>
        </div>
      </div>
      <figure className="services_right_shape mb-0 position-absolute top_bottom_shape">
        <img src="./assets/images/services_right_shape.png" alt className="img-fluid" />
      </figure>
    </div></section>
  {/* CONTACT MAP SECTION */}
  <div className="contact_map_section">
    <div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d462561.6574537445!2d55.22748795!3d25.076022449999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f43496ad9c645%3A0xbde66e5084295162!2sDubai%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1699347606733!5m2!1sen!2sin" width="100%" height={450} style={{border: 0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
      </div>
    </div>
  </div>
</div>

    </>
  )
}

export default CyberSecurityService